<template>
	<div class="md-layout">
		<div @click="$router.push('/empresas')" style="cursor: pointer;" class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
			<stats-card header-color="warning">
				<template slot="header">
					<div class="card-icon">
						<md-icon>business</md-icon>
					</div>
					<p class="category">Empresas cadastradas</p>
					<h3 class="title">
						<animated-number :value="stats.companies"></animated-number>
					</h3>
				</template>
			</stats-card>
		</div>
		<div @click="$router.push('/relatorios')" style="cursor: pointer;" class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
			<stats-card header-color="info">
				<template slot="header">
					<div class="card-icon">
						<md-icon>bookmarks</md-icon>
					</div>
					<p class="category">Acessos no último mês</p>
					<h3 class="title">
						<animated-number :value="stats.accessesLastMonth"></animated-number>
					</h3>
				</template>
			</stats-card>
		</div>
		<div @click="$router.push('/respostas')" style="cursor: pointer;" class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
			<stats-card header-color="danger">
				<template slot="header">
					<div class="card-icon">
						<md-icon>bookmark</md-icon>
					</div>
					<p class="category">Quantidade de respostas</p>
					<h3 class="title">
						<animated-number :value="stats.responses"></animated-number>
					</h3>
				</template>
			</stats-card>
		</div>
		<div @click="$router.push('/chats')" style="cursor: pointer;" class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
			<stats-card>
				<template slot="header">
					<div class="card-icon">
						<md-icon>chat</md-icon>
					</div>
					<p class="category">Conversas de chat pendentes</p>
					<h3 class="title">
						<animated-number :value="stats.pendingChat"></animated-number>
					</h3>
				</template>
			</stats-card>
		</div>
	</div>
</template>

<script>
import { StatsCard, AnimatedNumber } from '@/components';
import Stats from "@/models/stats.model.vue"

export default {
	components: {
		StatsCard,
		AnimatedNumber,
	},
	mounted() {
		Stats.getStats()
			.then(stats => {
				this.stats = stats;
				this.$root.$data.pendingChat = stats.pendingChat;
			})
			.catch(error => console.log(error));
	},
	data() {
		return {
			stats: {
				companies: 0,
				accessesLastMonth: 0,
				responses: 0,
			},
		}
  }

}
</script>
